<template>
    <div>
        <div elevation="0" color="transparent" flat>
            <div class="row mb-2">
                <div class="col-6 d-flex justify-content-start">
                    <v-card-title> Administration </v-card-title>
                </div>
            </div>
        </div>
        <div class="row mb-12">
            <div class="col-8 d-flex justify-content-start">
                <v-card-subtitle>
                    {{ $t("Administration.Categories.Manage") }}
                </v-card-subtitle>
            </div>
        </div>

        <div v-if="IsAdmin()" class="product-settings-text">
            {{ $t("Administration.Categories.Parameters") }}
        </div>

        <v-container v-if="IsAdmin()">
            <v-row>
                <v-col cols="12" md="4">
                    <v-card @click="() => goTo('Categories')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.Categories.Category") }}
                        </v-card-title>
                        <v-card-subtitle class="text-center">
                            {{ $t("Administration.Categories.ManageMsg") }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card @click="() => goTo('BrandsMenu')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.Brands.Brands") }}
                        </v-card-title>

                        <v-card-subtitle class="text-center">
                            {{ $t("Administration.Brands.ManageBrands") }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card @click="() => goTo('ProductTypeMenu')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.ProductType.ProductTypes") }}
                        </v-card-title>

                        <v-card-subtitle class="text-center">
                            {{
                                $t(
                                    "Administration.ProductType.ManageProductTypes"
                                )
                            }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-container v-if="IsSupplier()">
            <v-row>
                <v-col cols="12" md="4">
                    <v-card @click="() => goTo('BrandsMenu')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.Brands.Brands") }}
                        </v-card-title>

                        <v-card-subtitle class="text-center">
                            {{ $t("Administration.Brands.ManageBrands") }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <div class="product-settings-text">
            {{ $t("Administration.Users.Parameters") }}
        </div>
        <v-container>
            <v-row>
                <v-col cols="12" md="4" v-if="IsAdmin()">
                    <v-card @click="() => goTo('Configuration')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.Company.Company") }}
                        </v-card-title>
                        <v-card-subtitle class="text-center">
                            {{ $t("Administration.Company.ManageCompanies") }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4" v-if="IsAdmin()">
                    <v-card @click="() => goTo('PickupPoint')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.PickupPoint.PickupPoint") }}
                        </v-card-title>

                        <v-card-subtitle class="text-center">
                            {{
                                $t("Administration.PickupPoint.ManagePickupPoint")
                            }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card @click="() => goTo('Permissions')" class="centered-card">
                        <v-card-title class="text-center">
                            {{ $t("Administration.Permission.Permission") }}
                        </v-card-title>

                        <v-card-subtitle class="text-center">
                            {{
                                $t("Administration.Permission.ManagePermission")
                            }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { isClient, isSupplier } from "@/api/index";
export default {
    methods: {
        goTo(Value) {
            switch (Value) {
                case "Categories":
                    this.$router.push({ name: "Categories" });
                    break;
                case "BrandsMenu":
                    this.$router.push({ name: "BrandsMenu" });
                    break;
                case "DeliveryMenu":
                    this.$router.push({ name: "DeliveryMenu" });
                    break;
                case "DelivryOrdersMenu":
                    this.$router.push({ name: "DelivryOrdersMenu" });
                    break;
                case "Configuration":
                    this.$router.push({ name: "Configuration" });
                    break;
                case "Permissions":
                    this.$router.push({ name: "Permissions" });
                    break;
                case "ProductTypeMenu":
                    this.$router.push({ name: "ProductTypeMenu" });
                    break;
                case "PickupPoint":
                    this.$router.push({ name: "PickupPointMenu" });
                    break;
                default:
                    console.error("Destination non définie:", Value);
            }
        },
        IsAdmin() {
            return isClient();
        },
        IsSupplier() {
            return isSupplier();
        },
    },
};
</script>

<style scoped>
.centered-card {
    cursor: pointer;
    transition: box-shadow 0.3s;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.centered-card:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
}

.text-center {
    text-align: center;
    text-wrap: inherit;
}

v-card {
    height: 200px;
    width: 150px;
}

.product-settings-text {
    font-size: 16px;
    font-weight: bold;
    margin-top: 12px;
    margin-left: 14px;
    text-align: left;
    color: #001e50;
}
</style>
